import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select as MUISelect,
  TextField,
  Typography,
  Card,
  CardContent,
  CardActions,
  IconButton,
  Divider,
  Switch,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextareaAutosize,
} from "@mui/material";
import { FormHelperText } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Navbar from "./navigation";
import VerticalStepper from "./verticalStepper";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AdminNavbar from "./admin/AdminNav";
import MeasurementsSection from "./components/MeasurementsSection";
import api from "./api/api";
import { ENDPOINTS } from "./api/endpoints";
import Footer from "./Footer";
import ListItemText from "@mui/material/ListItemText";
import { Snackbar, Alert } from "@mui/material";

function RoleCreator() {
  const navigate = useNavigate();
  const location = useLocation();
  const [roles, setRoles] = useState([]);
  const [roleForm, setRoleForm] = useState({
    roleName: "",
    ageStart: "",
    ageEnd: "",
    sex: [],
    ethnicity: [],
    roleType: "",
    payment: "",
    reelRequired: 0,
    audioReelRequired: 0,
    moreAboutRole: "",
    otherMeasurements: "",
    PhotoorScriptName: null,
    PhotoorScriptFile: null,
    PhotoorScriptPath: "",
    heightStart: "",
    heightStartInches: "",
    heightEnd: "",
    heightEndInches: "",
    weightStart: "",
    weightEnd: "",
    eyeColor: [],
    hairColor: [],
    suitOne: "",
    suitTwo: "",
    suitOneAny: true,

    shirt: "",
    shirtAny: true,

    neckOne: "",
    neckTwo: "",
    neckOneAny: true,

    sleeveOne: "",
    sleeveTwo: "",
    sleeveOneAny: true,

    waistOne: "",
    waistTwo: "",
    waistOneAny: true,

    inseamOne: "",
    inseamTwo: "",
    inseamOneAny: true,

    shoeOne: "",
    shoeTwo: "",
    shoeOneAny: true,

    dressOne: "",
    dressTwo: "",
    dressOneAny: true,

    bustOne: "",
    bustTwo: "",
    bustOneAny: true,

    cup: "",
    cupAny: true,

    femaleWaistOne: "",
    femalWaistTwo: "",
    femaleWaistOneAny: true,

    hipsOne: "",
    hipsTwo: "",
    hipsOneAny: true,

    femaleShoeOne: "",
    femaleShoeTwo: "",
    femaleShoeOneAny: true,

    childSize: "",
    childSizeAny: true,

    childShoeOne: "",
    childShoeTwo: "",
    childShoeOneAny: true,

    vocalRange: [],
    vocalStyle: [],
  });

  //const fromPage = location.state?.fromPage || "postCastingCall";
  const [errors, setErrors] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const fileInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [roleId, setRoleId] = useState(null);
  const [eyeColorOptions, setEyeColorOptions] = useState([]);
  const [hairColorOptions, setHairColorOptions] = useState([]);
  const { noticeId, projectTitle, casting } = location.state || {};
  const [ethnicityOptions, setEthnicityOptions] = useState([]);
  const [vocalRangeOptions, setVocalRangeOptions] = useState([]);
  const [vocalStyleOptions, setVocalStyleOptions] = useState([]);
  const fromPage = location.state?.fromPage || "postCastingCall";
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const showToast = (message, severity = "success") => {
    setToast({ open: true, message, severity });
  };

  const validateFields = () => {
    const newErrors = {};

    if (!roleForm.roleName || roleForm.roleName.trim() === "") {
      newErrors.roleName = "Role name is required";
    }

    if (roleForm.ageStart === "" || isNaN(roleForm.ageStart)) {
      newErrors.ageStart = "Enter a valid minimum age";
    }

    if (roleForm.ageEnd === "" || isNaN(roleForm.ageEnd)) {
      newErrors.ageEnd = "Enter a valid maximum age";
    } else if (parseInt(roleForm.ageEnd) < parseInt(roleForm.ageStart || 0)) {
      newErrors.ageEnd = "Age Max must be ≥ Age Min";
    }

    if (!Array.isArray(roleForm.ethnicity) || roleForm.ethnicity.length === 0) {
      newErrors.ethnicity = "At least one ethnicity is required";
    }

    if (!roleForm.roleType || roleForm.roleType.trim() === "") {
      newErrors.roleType = "Role type is required";
    }
    if (
      roleForm.heightStart ||
      roleForm.heightStartInches ||
      roleForm.heightEnd ||
      roleForm.heightEndInches
    ) {
      const heightStartTotal = toInches(
        roleForm.heightStart,
        roleForm.heightStartInches,
      );
      const heightEndTotal = toInches(
        roleForm.heightEnd,
        roleForm.heightEndInches,
      );

      // Only validate if both heights have values (either feet or inches)
      const hasMinHeight = roleForm.heightStart || roleForm.heightStartInches;
      const hasMaxHeight = roleForm.heightEnd || roleForm.heightEndInches;

      if (hasMinHeight && hasMaxHeight && heightStartTotal > heightEndTotal) {
        newErrors.heightStart = "Min Height should be less than Max Height!";
      }

      // Validate maximum height limit (8 feet 12 inches = 108 inches)
      const maxHeight = 8 * 12 + 12; // 108 inches
      if (heightStartTotal > maxHeight) {
        newErrors.heightStart =
          "Min Height cannot be greater than 8'12\" (108 inches)!";
      }
      if (heightEndTotal > maxHeight) {
        newErrors.heightEnd =
          "Max Height cannot be greater than 8'12\" (108 inches)!";
      }
    }

    // WEIGHT VALIDATION - This was also missing!
    if (roleForm.weightStart && roleForm.weightEnd) {
      if (parseFloat(roleForm.weightStart) > parseFloat(roleForm.weightEnd)) {
        newErrors.weightStart = "Min Weight should be less than Max Weight!";
      }
    }
    // MEN'S CLOTHING SIZE VALIDATIONS
    if (roleForm.suitOne && roleForm.suitTwo) {
      if (parseFloat(roleForm.suitOne) > parseFloat(roleForm.suitTwo)) {
        newErrors.suitOne = "Min Suit size should be less than Max Suit size!";
      }
    }

    if (roleForm.neckOne && roleForm.neckTwo) {
      if (parseFloat(roleForm.neckOne) > parseFloat(roleForm.neckTwo)) {
        newErrors.neckOne = "Min Neck size should be less than Max Neck size!";
      }
    }

    if (roleForm.sleeveOne && roleForm.sleeveTwo) {
      if (parseFloat(roleForm.sleeveOne) > parseFloat(roleForm.sleeveTwo)) {
        newErrors.sleeveOne =
          "Min Sleeve length should be less than Max Sleeve length!";
      }
    }

    if (roleForm.waistOne && roleForm.waistTwo) {
      if (parseFloat(roleForm.waistOne) > parseFloat(roleForm.waistTwo)) {
        newErrors.waistOne =
          "Min Waist size should be less than Max Waist size!";
      }
    }

    if (roleForm.inseamOne && roleForm.inseamTwo) {
      if (parseFloat(roleForm.inseamOne) > parseFloat(roleForm.inseamTwo)) {
        newErrors.inseamOne = "Min Inseam should be less than Max Inseam!";
      }
    }

    if (roleForm.shoeOne && roleForm.shoeTwo) {
      if (parseFloat(roleForm.shoeOne) > parseFloat(roleForm.shoeTwo)) {
        newErrors.shoeOne = "Min Shoe size should be less than Max Shoe size!";
      }
    }

    // WOMEN'S CLOTHING SIZE VALIDATIONS
    if (roleForm.dressOne && roleForm.dressTwo) {
      if (parseFloat(roleForm.dressOne) > parseFloat(roleForm.dressTwo)) {
        newErrors.dressOne =
          "Min Dress size should be less than Max Dress size!";
      }
    }

    if (roleForm.bustOne && roleForm.bustTwo) {
      if (parseFloat(roleForm.bustOne) > parseFloat(roleForm.bustTwo)) {
        newErrors.bustOne = "Min Bust size should be less than Max Bust size!";
      }
    }

    if (roleForm.femaleWaistOne && roleForm.femalWaistTwo) {
      if (
        parseFloat(roleForm.femaleWaistOne) > parseFloat(roleForm.femalWaistTwo)
      ) {
        newErrors.femaleWaistOne =
          "Min Waist size should be less than Max Waist size!";
      }
    }

    if (roleForm.hipsOne && roleForm.hipsTwo) {
      if (parseFloat(roleForm.hipsOne) > parseFloat(roleForm.hipsTwo)) {
        newErrors.hipsOne = "Min Hip size should be less than Max Hip size!";
      }
    }

    if (roleForm.femaleShoeOne && roleForm.femaleShoeTwo) {
      if (
        parseFloat(roleForm.femaleShoeOne) > parseFloat(roleForm.femaleShoeTwo)
      ) {
        newErrors.femaleShoeOne =
          "Min Shoe size should be less than Max Shoe size!";
      }
    }

    // CHILDREN'S CLOTHING SIZE VALIDATIONS
    if (roleForm.childShoeOne && roleForm.childShoeTwo) {
      if (
        parseFloat(roleForm.childShoeOne) > parseFloat(roleForm.childShoeTwo)
      ) {
        newErrors.childShoeOne =
          "Min Shoe size should be less than Max Shoe size!";
      }
    }

    if (!Array.isArray(roleForm.sex) || roleForm.sex.length === 0) {
      newErrors.sex = "At least one gender is required";
    }

    if (!Array.isArray(roleForm.ethnicity) || roleForm.ethnicity.length === 0) {
      newErrors.ethnicity = "At least one ethnicity is required";
    }

    if (!roleForm.roleType || roleForm.roleType.trim() === "") {
      newErrors.roleType = "Role type is required";
    }
    if (roleForm.moreAboutRole && roleForm.moreAboutRole.length > 1000) {
      newErrors.moreAboutRole = "Description cannot exceed 1000 characters.";
    }
    if (roleForm.payment && roleForm.payment.length > 1000) {
      newErrors.payment = "Pay for this role cannot exceed 1000 characters.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const menSizes = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL"];
  const cupSizes = ["AA", "A", "B", "C", "D", "DD", "DDD", "E", "F", "G", "H"];
  const childClothing = [
    "6 mos.",
    "12 mos.",
    "18 mos.",
    "S",
    "M",
    "L",
    "XL",
    "XXL",
  ];

  const measurementFields = {
    mens: [
      {
        label: "Suit (chest in)",
        name: "suitOne",
        maxName: "suitTwo",
        anyFlag: "suitOneAny",
        type: "range",
        min: 30,
        max: 58,
        step: 2,
      },
      {
        label: "Shirt",
        name: "shirt",
        type: "select",
        options: menSizes,
      },
      {
        label: "Neck (in)",
        name: "neckOne",
        maxName: "neckTwo",
        anyFlag: "neckOneAny",
        type: "range",
        min: 14,
        max: 19,
        step: 0.5,
      },
      {
        label: "Sleeve (in)",
        name: "sleeveOne",
        maxName: "sleeveTwo",
        anyFlag: "sleeveOneAny",
        type: "range",
        min: 30,
        max: 40,
        step: 1,
      },
      {
        label: "Waist (in)",
        name: "waistOne",
        maxName: "waistTwo",
        anyFlag: "waistOneAny",
        type: "range",
        min: 24,
        max: 50,
        step: 1,
      },
      {
        label: "Inseam (in)",
        name: "inseamOne",
        maxName: "inseamTwo",
        anyFlag: "inseamOneAny",
        type: "range",
        min: 28,
        max: 40,
        step: 1,
      },
      {
        label: "Shoe",
        name: "shoeOne",
        maxName: "shoeTwo",
        anyFlag: "shoeOneAny",
        type: "range",
        min: 5,
        max: 15,
        step: 0.5,
      },
    ],
    womens: [
      {
        label: "Dress (US)",
        name: "dressOne",
        maxName: "dressTwo",
        anyFlag: "dressOneAny",
        type: "range",
        min: 0,
        max: 20,
        step: 1,
      },
      {
        label: "Bust (in)",
        name: "bustOne",
        maxName: "bustTwo",
        anyFlag: "bustOneAny",
        type: "range",
        min: 28,
        max: 50,
        step: 1,
      },
      {
        label: "Cup (opt)",
        name: "cup",
        type: "select",
        options: cupSizes,
      },
      {
        label: "Waist (in)",
        name: "femaleWaistOne",
        maxName: "femalWaistTwo",
        anyFlag: "femaleWaistOneAny",
        type: "range",
        min: 20,
        max: 40,
        step: 1,
      },
      {
        label: "Hips (in)",
        name: "hipsOne",
        maxName: "hipsTwo",
        anyFlag: "hipsOneAny",
        type: "range",
        min: 30,
        max: 50,
        step: 1,
      },
      {
        label: "Shoe",
        name: "femaleShoeOne",
        maxName: "femaleShoeTwo",
        anyFlag: "femaleShoeOneAny",
        type: "range",
        min: 4,
        max: 13,
        step: 0.5,
      },
    ],
    kids: [
      {
        label: "Size",
        name: "childSize",
        type: "select",
        options: childClothing,
        anyFlag: "childSizeAny",
      },
      {
        label: "Shoe",
        name: "childShoeOne",
        maxName: "childShoeTwo",
        anyFlag: "childShoeOneAny",
        type: "range",
        min: 1,
        max: 5,
        step: 0.5,
      },
    ],
  };

  const toInches = (feet, inches) => {
    const ft = parseInt(feet, 10) || 0;
    const inCh = parseInt(inches, 10) || 0;
    return ft * 12 + inCh;
  };
  const stepTitles = ["Project Details", "Role Creator", "Preview Notice"];

  const userRole = localStorage.getItem("userRole");

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    let val;

    if (type === "file") {
      val = files[0];
    } else if (type === "number") {
      // parse as float, default to 0, then clamp
      const num = parseFloat(value) || 0;
      val = Math.min(1000, Math.max(0, num)).toString();
    } else {
      val = value;
    }

    setRoleForm((prev) => ({
      ...prev,
      [name]: val,
    }));
  };
  useEffect(() => {
    const fetchLookups = async () => {
      try {
        const [eyeRes, hairRes, ethnicityRes, vocalRangeRes, vocalTypeRes] =
          await Promise.all([
            api.get(ENDPOINTS.getEyeColors()),
            api.get(ENDPOINTS.getHairColors()),
            api.get(ENDPOINTS.getEthnicities()),
            api.get(ENDPOINTS.getVocalRanges()),
            api.get(ENDPOINTS.getVocalTypes()),
          ]);

        setEyeColorOptions(eyeRes.data.data || []);
        setHairColorOptions(hairRes.data.data || []);
        setEthnicityOptions(ethnicityRes.data.data || []);
        setVocalRangeOptions(vocalRangeRes.data.data || []);
        // vocalType has no { status, data } wrapper — it's a bare array
        setVocalStyleOptions(vocalTypeRes.data || []);
      } catch (error) {
        console.error("Failed to fetch lookup options", error);
      }
    };

    fetchLookups();
  }, []);

  useEffect(() => {
    if (location.state?.role) {
      const role = location.state.role;
      handleEdit(role.roleId, role);
    }
  }, [location.state]);

  const handleCheckbox = (name) => {
    setRoleForm((prev) => ({ ...prev, [name]: prev[name] === 1 ? 0 : 1 }));
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const allowed = [
      "application/pdf",
      "text/html",
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
      "image/bmp",
      "image/tiff",
      "image/svg+xml",
      "image/heic",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.apple.pages",
    ];
    if (!allowed.includes(file.type)) {
      showToast(`Invalid file type: ${file.type}`);
      return;
    }

    setRoleForm((prev) => ({
      ...prev,
      PhotoorScriptFile: file,
      PhotoorScriptName: file.name,
    }));
  };
  const handleCheckboxChange = (field, value) => {
    setRoleForm((prev) => {
      const updated = [...prev[field]];
      if (updated.includes(value)) {
        return { ...prev, [field]: updated.filter((item) => item !== value) };
      } else {
        return { ...prev, [field]: [...updated, value] };
      }
    });
  };

  const handleVocalChange = (type, value) => {
    setRoleForm((prev) => {
      const list = [...prev[type]];
      if (list.includes(value)) {
        return { ...prev, [type]: list.filter((v) => v !== value) };
      } else {
        return { ...prev, [type]: [...list, value] };
      }
    });
  };

  const addRoleToList = () => {
    setRoles((prev) => [...prev, { ...roleForm, id: Date.now() }]);
    setRoleForm((prev) => ({
      ...prev,
      roleName: "",
      ageStart: "",
      ageEnd: "",
      sex: [],
      ethnicity: [],
      roleType: "",
      payment: "",
      reelRequired: 0,
      audioReelRequired: 0,
      moreAboutRole: "",
      heightStart: "",
      heightStartInches: "",
      heightEnd: "",
      heightEndInches: "",
      weightStart: "",
      weightEnd: "",
      dressOne: "",
      bustOne: "",
      cup: "",
      waistOne: "",
      hipsOne: "",
      suitOne: "",
      shirt: "",
      neckOne: "",
      sleeveOne: "",
      inseamOne: "",
      shoeOne: "",
      femaleShoeOne: "",
      childSize: "",
      childShoeOne: "",
      eyeColor: [],
      hairColor: [],
      vocalRange: [],
      vocalStyle: [],
      PhotoorScriptName: null,
      PhotoorScriptFile: null,
      PhotoorScriptPath: "",
    }));
  };
  const resetForm = () => {
    setRoleForm({
      roleName: "",
      ageStart: "",
      ageEnd: "",
      sex: [],
      ethnicity: [],
      roleType: "",
      payment: "",
      reelRequired: 0,
      audioReelRequired: 0,
      moreAboutRole: "",
      otherMeasurements: "",
      PhotoorScriptName: null,
      PhotoorScriptFile: null,
      PhotoorScriptPath: "",

      // height & weight
      heightStart: "",
      heightStartInches: "",
      heightEnd: "",
      heightEndInches: "",
      weightStart: "",
      weightEnd: "",

      // eye & hair
      eyeColor: [],
      hairColor: [],

      // mens sizes
      suitOne: "",
      suitTwo: "",
      suitOneAny: true,

      shirt: "",
      shirtAny: true,

      neckOne: "",
      neckTwo: "",
      neckOneAny: true,

      sleeveOne: "",
      sleeveTwo: "",
      sleeveOneAny: true,

      waistOne: "",
      waistTwo: "",
      waistOneAny: true,

      inseamOne: "",
      inseamTwo: "",
      inseamOneAny: true,

      shoeOne: "",
      shoeTwo: "",
      shoeOneAny: true,

      // womens sizes
      dressOne: "",
      dressTwo: "",
      dressOneAny: true,

      bustOne: "",
      bustTwo: "",
      bustOneAny: true,

      cup: "",
      cupAny: true,

      femaleWaistOne: "",
      femalWaistTwo: "",
      femaleWaistOneAny: true,

      hipsOne: "",
      hipsTwo: "",
      hipsOneAny: true,

      femaleShoeOne: "",
      femaleShoeTwo: "",
      femaleShoeOneAny: true,

      // kids sizes
      childSize: "",
      childSizeAny: true,

      childShoeOne: "",
      childShoeTwo: "",
      childShoeOneAny: true,

      // vocals
      vocalRange: [],
      vocalStyle: [],
    });
  };

  // inside RoleCreator component

  const submitRoleToServer = async () => {
    if (!validateFields()) return;
    setIsLoading(true);
    const heightStartInches = toInches(
      roleForm.heightStart, // ← Fixed: was heightEnd
      roleForm.heightStartInches,
    );
    const heightEndInches = toInches(
      roleForm.heightEnd,
      roleForm.heightEndInches,
    );

    const getRange = (name, maxName) => {
      const any = roleForm[name + "Any"];
      const min = parseFloat(roleForm[name]) || 0;
      const max = parseFloat(roleForm[maxName]) || 0;
      return {
        one: any ? 0 : min,
        two: any ? 0 : max,
      };
    };

    const toInt = (raw) => {
      const n = parseInt(raw, 10);
      return Number.isFinite(n) && n >= 0 ? n : undefined;
    };
    const toFloat = (raw) => {
      const f = parseFloat(raw);
      return Number.isFinite(f) && f >= 0 ? f : undefined;
    };
    const toInchesInt = (ft, inch) => {
      if (!ft && !inch) return undefined;
      const total = toInches(ft, inch);
      const n = parseInt(total, 10);
      return Number.isFinite(n) && n >= 0 ? n : undefined;
    };
    const guardString = (s, max = 255) =>
      typeof s === "string" && s.trim() && s.length <= max
        ? s.trim()
        : undefined;

    const rawPayload = {
      RoleId: toInt(roleId),
      NoticeId: toInt(noticeId),

      RoleUnion: guardString(roleForm.union),
      RoleName: guardString(roleForm.roleName),
      Sex: guardString(
        Array.isArray(roleForm.sex) ? roleForm.sex.join(",") : "",
        200,
      ),
      Ethnicity: guardString(
        Array.isArray(roleForm.ethnicity) ? roleForm.ethnicity.join(",") : "",
        1000,
      ),
      RoleType: guardString(roleForm.roleType, 100),
      Payment: guardString(roleForm.payment, 1000),
      PhotoorScriptPath: guardString(roleForm.PhotoorScriptPath, 1024),

      ReelRequired: roleForm.reelRequired ? 1 : 0,
      AudioReelRequired: roleForm.audioReelRequired ? 1 : 0,

      AgeStart: toInt(roleForm.ageStart),
      AgeEnd: toInt(roleForm.ageEnd),

      HeightStart: toInchesInt(
        roleForm.heightStart,
        roleForm.heightStartInches,
      ),
      HeightEnd: toInchesInt(roleForm.heightEnd, roleForm.heightEndInches),

      WeightStart: toFloat(roleForm.weightStart),
      WeightEnd: toFloat(roleForm.weightEnd),

      EyeColor: guardString(
        Array.isArray(roleForm.eyeColor) ? roleForm.eyeColor.join(",") : "",
        200,
      ),
      HairColor: guardString(
        Array.isArray(roleForm.hairColor) ? roleForm.hairColor.join(",") : "",
        200,
      ),

      ...(roleForm.suitOne || roleForm.suitTwo
        ? (() => {
            const { one, two } = getRange("suitOne", "suitTwo");
            return { SuitOne: toInt(one), SuitTwo: toInt(two) };
          })()
        : {}),

      ...(roleForm.neckOne || roleForm.neckTwo
        ? (() => {
            const { one, two } = getRange("neckOne", "neckTwo");
            return { NeckOne: toInt(one), NeckTwo: toInt(two) };
          })()
        : {}),

      ...(roleForm.sleeveOne || roleForm.sleeveTwo
        ? (() => {
            const { one, two } = getRange("sleeveOne", "sleeveTwo");
            return { SleeveOne: toInt(one), SleeveTwo: toInt(two) };
          })()
        : {}),

      ...(roleForm.waistOne || roleForm.waistTwo
        ? (() => {
            const { one, two } = getRange("waistOne", "waistTwo");
            return { WaistOne: toInt(one), WaistTwo: toInt(two) };
          })()
        : {}),

      ...(roleForm.inseamOne || roleForm.inseamTwo
        ? (() => {
            const { one, two } = getRange("inseamOne", "inseamTwo");
            return { InseamOne: toInt(one), InseamTwo: toInt(two) };
          })()
        : {}),

      ...(roleForm.shoeOne || roleForm.shoeTwo
        ? (() => {
            const { one, two } = getRange("shoeOne", "shoeTwo");
            return { ShoeOne: toInt(one), ShoeTwo: toInt(two) };
          })()
        : {}),

      Shirt: guardString(roleForm.shirt, 50),

      // Women's sizes
      ...(roleForm.dressOne || roleForm.dressTwo
        ? (() => {
            const { one, two } = getRange("dressOne", "dressTwo");
            return { DressOne: toInt(one), DressTwo: toInt(two) };
          })()
        : {}),

      ...(roleForm.bustOne || roleForm.bustTwo
        ? (() => {
            const { one, two } = getRange("bustOne", "bustTwo");
            return { BustOne: toInt(one), BustTwo: toInt(two) };
          })()
        : {}),

      Cup: guardString(roleForm.cup, 10),

      ...(roleForm.femaleWaistOne || roleForm.femalWaistTwo
        ? (() => {
            const { one, two } = getRange("femaleWaistOne", "femalWaistTwo");
            return { FemalWaistOne: toInt(one), FemalWaistTwo: toInt(two) };
          })()
        : {}),

      ...(roleForm.hipsOne || roleForm.hipsTwo
        ? (() => {
            const { one, two } = getRange("hipsOne", "hipsTwo");
            return { HipsOne: toInt(one), HipsTwo: toInt(two) };
          })()
        : {}),

      ...(roleForm.femaleShoeOne || roleForm.femaleShoeTwo
        ? (() => {
            const { one, two } = getRange("femaleShoeOne", "femaleShoeTwo");
            return { FemaleShoeOne: toInt(one), FemaleShoeTwo: toInt(two) };
          })()
        : {}),

      // Kids' sizes
      ChildSize: guardString(roleForm.childSize, 20),

      ...(roleForm.childShoeOne || roleForm.childShoeTwo
        ? (() => {
            const { one, two } = getRange("childShoeOne", "childShoeTwo");
            return { ChildShoeOne: toInt(one), ChildShoeTwo: toInt(two) };
          })()
        : {}),

      OtherMeasurements: guardString(roleForm.otherMeasurements, 500),

      VocalRange:
        Array.isArray(roleForm.vocalRange) && roleForm.vocalRange.length
          ? JSON.stringify(roleForm.vocalRange)
          : undefined,
      VocalStyle:
        Array.isArray(roleForm.vocalStyle) && roleForm.vocalStyle.length
          ? JSON.stringify(roleForm.vocalStyle)
          : undefined,

      MoreAboutRole: guardString(roleForm.moreAboutRole, 1000),
      PhotoorScriptName: guardString(roleForm.PhotoorScriptName, 255),

      RecordCreatedDate: roleId
        ? roleForm.recordCreatedDate // use existing if editing
        : new Date().toISOString(), // generate new if adding

      dateModified: new Date().toISOString(),
    };

    const payload = Object.fromEntries(
      Object.entries(rawPayload).filter(([_, v]) => v !== undefined),
    );

    // now append to FormData
    const formData = new FormData();
    Object.entries(payload).forEach(([key, val]) => {
      formData.append(key, val);
    });
    if (roleForm.PhotoorScriptFile) {
      formData.append("PhotoorScriptFile", roleForm.PhotoorScriptFile);
    }

    try {
      const res = await api.post(ENDPOINTS.addOrUpdateRole(), formData);
      showToast(roleId ? "Role updated!" : "Role added!", "success");
      fetchRoles();
      setRoleId(null);
      resetForm();
    } catch (err) {
      console.error(err);
      showToast("Failed to save role", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = (id, role) => {
    setRoleId(id);

    // convert total inches → { feet, inches }
    const convert = (total = 0) => ({
      feet: Math.floor(total / 12),
      inches: total % 12,
    });

    const hs = convert(role.heightStart);
    const he = convert(role.heightEnd);
    setRoleForm({
      // Basic Info
      roleName: role.roleName || "",
      sex: Array.isArray(role.sex)
        ? role.sex
        : role.sex
          ? role.sex.split(",").map((s) => s.trim())
          : [],
      ethnicity: Array.isArray(role.ethnicity)
        ? role.ethnicity
        : role.ethnicity
          ? role.ethnicity.split(",")
          : [],
      roleType: role.roleType || "",
      payment: role.payment || "",
      reelRequired: role.reelRequired,
      audioReelRequired: role.audioReelRequired,
      moreAboutRole: role.moreAboutRole || "",
      otherMeasurements: role.otherMeasurements || "",
      PhotoorScriptName: role.photoorScriptName || null,
      PhotoorScriptFile: null,
      PhotoorScriptPath: role.photoorScriptPath,
      // Age (strings if >0)
      ageStart: role.ageStart != null ? String(role.ageStart) : "",
      ageEnd: role.ageEnd != null ? String(role.ageEnd) : "",

      // Height & Weight (strings if >0)
      heightStart: hs.feet > 0 ? String(hs.feet) : "",
      heightStartInches: hs.inches > 0 ? String(hs.inches) : "",
      heightEnd: he.feet > 0 ? String(he.feet) : "",
      heightEndInches: he.inches > 0 ? String(he.inches) : "",
      weightStart: role.weightStart > 0 ? String(role.weightStart) : "",
      weightEnd: role.weightEnd > 0 ? String(role.weightEnd) : "",

      eyeColor: Array.isArray(role.eyeColor)
        ? role.eyeColor
        : role.eyeColor
          ? role.eyeColor.split(",").map((s) => s.trim())
          : [],
      hairColor: Array.isArray(role.hairColor)
        ? role.hairColor
        : role.hairColor
          ? role.hairColor.split(",").map((s) => s.trim())
          : [],

      // Men's Sizes
      suitOne: String(role.suitOne > 0 ? role.suitOne : ""),
      suitTwo: String(role.suitTwo > 0 ? role.suitTwo : ""),
      suitOneAny: !(role.suitOne > 0 || role.suitTwo > 0),

      shirt: role.shirt || "",
      shirtAny: !role.shirt,

      neckOne: String(role.neckOne > 0 ? role.neckOne : ""),
      neckTwo: String(role.neckTwo > 0 ? role.neckTwo : ""),
      neckOneAny: !(role.neckOne > 0 || role.neckTwo > 0),

      sleeveOne: String(role.sleeveOne > 0 ? role.sleeveOne : ""),
      sleeveTwo: String(role.sleeveTwo > 0 ? role.sleeveTwo : ""),
      sleeveOneAny: !(role.sleeveOne > 0 || role.sleeveTwo > 0),

      waistOne: String(role.waistOne > 0 ? role.waistOne : ""),
      waistTwo: String(role.waistTwo > 0 ? role.waistTwo : ""),
      waistOneAny: !(role.waistOne > 0 || role.waistTwo > 0),

      inseamOne: String(role.inseamOne > 0 ? role.inseamOne : ""),
      inseamTwo: String(role.inseamTwo > 0 ? role.inseamTwo : ""),
      inseamOneAny: !(role.inseamOne > 0 || role.inseamTwo > 0),

      shoeOne: String(role.shoeOne > 0 ? role.shoeOne : ""),
      shoeTwo: String(role.shoeTwo > 0 ? role.shoeTwo : ""),
      shoeOneAny: !(role.shoeOne > 0 || role.shoeTwo > 0),

      // Women's Sizes
      dressOne: String(role.dressOne > 0 ? role.dressOne : ""),
      dressTwo: String(role.dressTwo > 0 ? role.dressTwo : ""),
      dressOneAny: !(role.dressOne > 0 || role.dressTwo > 0),

      bustOne: String(role.bustOne > 0 ? role.bustOne : ""),
      bustTwo: String(role.bustTwo > 0 ? role.bustTwo : ""),
      bustOneAny: !(role.bustOne > 0 || role.bustTwo > 0),

      cup: role.cup || "",
      cupAny: !role.cup,

      femaleWaistOne: String(role.femalWaistOne > 0 ? role.femalWaistOne : ""),
      femalWaistTwo: String(role.femalWaistTwo > 0 ? role.femalWaistTwo : ""),
      femaleWaistOneAny: !(role.femalWaistOne > 0 || role.femalWaistTwo > 0),

      hipsOne: String(role.hipsOne > 0 ? role.hipsOne : ""),
      hipsTwo: String(role.hipsTwo > 0 ? role.hipsTwo : ""),
      hipsOneAny: !(role.hipsOne > 0 || role.hipsTwo > 0),

      femaleShoeOne: String(role.femaleShoeOne > 0 ? role.femaleShoeOne : ""),
      femaleShoeTwo: String(role.femaleShoeTwo > 0 ? role.femaleShoeTwo : ""),
      femaleShoeOneAny: !(role.femaleShoeOne > 0 || role.femaleShoeTwo > 0),

      // Kids' Sizes
      childSize: role.childSize || "",
      childSizeAny: !role.childSize,
      childShoeOne: String(role.childShoeOne > 0 ? role.childShoeOne : ""),
      childShoeTwo: String(role.childShoeTwo > 0 ? role.childShoeTwo : ""),
      childShoeOneAny: !(role.childShoeOne > 0 || role.childShoeTwo > 0),
      recordCreatedDate: role.recordCreatedDate || null,

      // Vocals
      vocalRange: role.vocalRange ? JSON.parse(role.vocalRange) : [],
      vocalStyle: role.vocalStyle ? JSON.parse(role.vocalStyle) : [],
    });
  };

  const deleteRole = async (roleId) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete the role?`,
    );
    if (!isConfirmed) return;

    try {
      // Axios returns the parsed JSON in response.data
      const response = await api.delete(ENDPOINTS.deleteRole({ roleId }), {
        params: { roleId },
      });
      const payload = response.data;

      // Check your API's status field
      if (payload.status !== "OK" || payload.data !== true) {
        throw new Error(`Delete failed: ${payload.message || "unknown error"}`);
      }

      showToast("Role deleted successfully!", "success");
      fetchRoles(noticeId);
    } catch (error) {
      console.error("Error deleting role:", error);
      showToast("An error occurred while deleting the role.");
    }
  };

  const fetchRoles = async () => {
    try {
      const { data: payload } = await api.get(
        ENDPOINTS.getRoleDetails({ noticeId, page: 1, pageSize: 50 }),
      );
      const sortedRoles = (payload.data?.items || []).sort(
        (a, b) => new Date(a.recordCreatedDate) - new Date(b.recordCreatedDate),
      );
      setRoles(sortedRoles);
    } catch (err) {
      console.error("Failed to fetch roles", err);
    }
  };

  const handleSaveAndContinue = () => {
    navigate("/SummaryDetails", { state: { noticeId, projectTitle } });
  };
  const renderSizeDropdown = (label, name, options) => (
    <Grid item xs={12} md={3}>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <MUISelect
          label={label}
          name={name}
          value={roleForm[name] || ""}
          onChange={handleChange}
        >
          {options.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </MUISelect>
      </FormControl>
    </Grid>
  );
  useEffect(() => {
    if (noticeId) fetchRoles();
  }, [noticeId]);

  return (
    <>
      {userRole === "ADMIN" ? <AdminNavbar /> : <Navbar />}
      <Box className="background-prop">
        <VerticalStepper
          stepTitles={stepTitles}
          currentStep={currentStep}
          onStepClick={(index) => setCurrentStep(index)}
        />

        <Box className="shadow" sx={{ p: 3, maxWidth: 1200, m: "auto" }}>
          <Box display="flex" flexWrap="wrap" gap={0}>
            <Box sx={{ width: { xs: "100%", md: "75%" }, pr: 1 }}>
              <Typography variant="h6" gutaterBottom>
                Create a New Role
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Role Name *"
                    name="roleName"
                    value={roleForm.roleName}
                    onChange={handleChange}
                    error={!!errors.roleName}
                    helperText={errors.roleName}
                    onBlur={validateFields}
                  />
                </Grid>

                <Grid item xs={6} md={3}>
                  <TextField
                    fullWidth
                    label="Age Min"
                    name="ageStart"
                    value={roleForm.ageStart}
                    onChange={handleChange}
                    type="number"
                    error={!!errors.ageStart}
                    helperText={errors.ageStart}
                    onBlur={validateFields}
                  />
                </Grid>

                <Grid item xs={6} md={3}>
                  <TextField
                    fullWidth
                    label="Age Max"
                    name="ageEnd"
                    value={roleForm.ageEnd}
                    onChange={handleChange}
                    type="number"
                    error={!!errors.ageEnd}
                    helperText={errors.ageEnd}
                    onBlur={validateFields}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth error={!!errors.sex}>
                    <InputLabel>Gender</InputLabel>
                    <MUISelect
                      multiple
                      name="sex"
                      value={roleForm.sex}
                      onChange={handleChange}
                      input={<OutlinedInput label="Gender" />}
                      renderValue={(selected) => (selected || []).join(", ")}
                      onBlur={() => validateFields("sex", roleForm.sex)}
                    >
                      {[
                        "Any Gender",
                        "Male",
                        "Female",
                        "Trans Male",
                        "Trans Female",
                        "Non-Binary",
                      ].map((g) => (
                        <MenuItem key={g} value={g}>
                          <Checkbox checked={roleForm.sex.includes(g)} />
                          <ListItemText primary={g} />
                        </MenuItem>
                      ))}
                    </MUISelect>
                    {errors.sex && (
                      <FormHelperText>{errors.sex}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControl fullWidth error={!!errors.ethnicity}>
                    <InputLabel>Ethnicity</InputLabel>

                    <MUISelect
                      multiple
                      name="ethnicity"
                      value={roleForm.ethnicity}
                      onChange={(e) => {
                        let value = e.target.value;

                        // Make "Any Ethnicity" mutually exclusive
                        if (value.includes("Any Ethnicity")) {
                          if (
                            roleForm.ethnicity.includes("Any Ethnicity") &&
                            value.length > 1
                          ) {
                            // User selected another ethnicity while "Any Ethnicity" was already selected
                            value = value.filter((v) => v !== "Any Ethnicity");
                          } else {
                            // User selected "Any Ethnicity"
                            value = ["Any Ethnicity"];
                          }
                        }

                        setRoleForm((prev) => ({
                          ...prev,
                          ethnicity: value,
                        }));

                        validateFields("ethnicity", value);
                      }}
                      input={<OutlinedInput label="Ethnicity" />}
                      renderValue={(selected) => (selected || []).join(", ")}
                      onBlur={() =>
                        validateFields("ethnicity", roleForm.ethnicity)
                      }
                    >
                      {/* Any Ethnicity */}
                      <MenuItem
                        value="Any Ethnicity"
                        disabled={
                          roleForm.ethnicity.length > 0 &&
                          !roleForm.ethnicity.includes("Any Ethnicity")
                        }
                      >
                        <Checkbox
                          checked={roleForm.ethnicity.includes("Any Ethnicity")}
                        />
                        <ListItemText primary="Any Ethnicity" />
                      </MenuItem>

                      {/* Other Ethnicities */}
                      {ethnicityOptions
                        .filter((e) => e.activeFlag)
                        .map((e) => (
                          <MenuItem
                            key={e.ethnicityId}
                            value={e.ethnicityName}
                            disabled={roleForm.ethnicity.includes(
                              "Any Ethnicity",
                            )}
                          >
                            <Checkbox
                              checked={roleForm.ethnicity.includes(
                                e.ethnicityName,
                              )}
                            />
                            <ListItemText primary={e.ethnicityName} />
                          </MenuItem>
                        ))}
                    </MUISelect>

                    {errors.ethnicity && (
                      <FormHelperText>{errors.ethnicity}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth error={!!errors.roleType}>
                    <InputLabel>Role Type</InputLabel>
                    <MUISelect
                      name="roleType"
                      value={roleForm.roleType}
                      label="Role Type"
                      onChange={(e) => {
                        handleChange(e);
                        validateFields("roleType", e.target.value);
                      }}
                      onBlur={() =>
                        validateFields("roleType", roleForm.roleType)
                      }
                    >
                      {[
                        "Principal",
                        "Supporting",
                        "Co-Star",
                        "Day Player",
                        "Voice-Over",
                        "Stunts",
                        "Chorus / Ensemble",
                        "Special Ability",
                        "Precision Driver",
                        "Stand-In",
                        "Photo Double",
                        "Extras",
                        "N/A",
                      ].map((r) => (
                        <MenuItem key={r} value={r}>
                          {r}
                        </MenuItem>
                      ))}
                    </MUISelect>
                    {errors.roleType && (
                      <FormHelperText>{errors.roleType}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Pay for this role"
                    name="payment"
                    value={roleForm.payment}
                    onChange={handleChange}
                    placeholder="Enter payment details (e.g. $500/day, TBD, etc.)"
                    error={!!errors.payment}
                    helperText={
                      errors.payment
                        ? errors.payment
                        : `${roleForm.payment.length}/1000 characters`
                    }
                    onBlur={validateFields}
                  />
                </Grid>

                <Grid item xs={6} md={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={roleForm.reelRequired === 1}
                        onChange={() => handleCheckbox("reelRequired")}
                        color="primary"
                      />
                    }
                    label="Must have Reel"
                  />
                </Grid>
                <Grid item xs={6} md={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={roleForm.audioReelRequired === 1}
                        onChange={() => handleCheckbox("audioReelRequired")}
                        color="primary"
                      />
                    }
                    label="Must have Audio"
                  />
                </Grid>

                <Grid item xs={12}>
                  <FormControl fullWidth error={!!errors.moreAboutRole}>
                    <TextareaAutosize
                      minRows={4}
                      placeholder="More About Character/Role (max 1000 characters)"
                      name="moreAboutRole"
                      value={roleForm.moreAboutRole}
                      onChange={handleChange}
                      onBlur={validateFields}
                      style={{
                        width: "100%",
                        fontSize: 16,
                        padding: "16.5px 14px",
                        boxSizing: "border-box",
                        resize: "vertical",
                      }}
                    />
                    <FormHelperText>
                      {errors.moreAboutRole
                        ? errors.moreAboutRole
                        : `${roleForm.moreAboutRole.length}/1000 characters`}
                    </FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Button variant="contained" component="label">
                    Upload Script or Photo
                    <input
                      type="file"
                      hidden
                      ref={fileInputRef}
                      onChange={handleFileUpload}
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.gif,.webp,.svg,.bmp,.tiff,.heic,.pages"
                    />
                  </Button>
                  {roleForm.PhotoorScriptName && (
                    <Box mt={1} display="flex" alignItems="center" gap={1}>
                      <Typography variant="body2">
                        {roleForm.PhotoorScriptName}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setRoleForm((prev) => ({
                            ...prev,
                            PhotoorScriptName: null,
                            PhotoorScriptFile: null,
                            PhotoorScriptPath: "",
                          }));
                          if (fileInputRef.current) {
                            fileInputRef.current.value = null;
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                </Grid>
              </Grid>
              <Box mt={2}>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">
                      Physical Characteristics
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      {/* Height Min */}
                      <Grid item xs={6} md={3}>
                        <TextField
                          label="Min Height (Feet)"
                          name="heightStart"
                          value={roleForm.heightStart}
                          onChange={handleChange}
                          fullWidth
                          type="number"
                          error={!!errors.heightStart}
                          helperText={errors.heightStart}
                        />
                      </Grid>

                      <Grid item xs={6} md={3}>
                        <TextField
                          label="Min Height (Inches)"
                          name="heightStartInches"
                          value={roleForm.heightStartInches}
                          onChange={handleChange}
                          fullWidth
                          type="number"
                        />
                      </Grid>

                      <Grid item xs={6} md={3}>
                        <TextField
                          label="Max Height (Feet)"
                          name="heightEnd"
                          value={roleForm.heightEnd}
                          onChange={handleChange}
                          fullWidth
                          type="number"
                          error={!!errors.heightEnd}
                          helperText={errors.heightEnd}
                        />
                      </Grid>

                      <Grid item xs={6} md={3}>
                        <TextField
                          label="Max Height (Inches)"
                          name="heightEndInches"
                          value={roleForm.heightEndInches}
                          onChange={handleChange}
                          fullWidth
                          type="number"
                        />
                      </Grid>

                      {/* Weight */}
                      <Grid item xs={6} md={3}>
                        <TextField
                          fullWidth
                          label="Min Weight (lbs)"
                          name="weightStart"
                          value={roleForm.weightStart}
                          onChange={handleChange}
                          type="number"
                          error={!!errors.weightStart}
                          helperText={errors.weightStart}
                        />
                      </Grid>

                      <Grid item xs={6} md={3}>
                        <TextField
                          fullWidth
                          label="Max Weight (lbs)"
                          name="weightEnd"
                          value={roleForm.weightEnd}
                          onChange={handleChange}
                          type="number"
                          error={!!errors.weightEnd}
                          helperText={errors.weightEnd}
                        />
                      </Grid>

                      {/* Eye Color */}
                      <Grid item xs={6} md={3}>
                        <FormControl fullWidth>
                          <InputLabel>Eye Color</InputLabel>
                          <MUISelect
                            multiple
                            name="eyeColor"
                            value={roleForm.eyeColor}
                            onChange={handleChange}
                            input={<OutlinedInput label="Eye Color" />}
                            renderValue={(selected) =>
                              (selected || []).join(", ")
                            }
                          >
                            {eyeColorOptions
                              .filter((color) => color.activeFlag)
                              .map((color) => (
                                <MenuItem
                                  key={color.eyeColorId}
                                  value={color.eyeColorName}
                                >
                                  <Checkbox
                                    checked={roleForm.eyeColor.includes(
                                      color.eyeColorName,
                                    )}
                                  />
                                  <ListItemText primary={color.eyeColorName} />
                                </MenuItem>
                              ))}
                          </MUISelect>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6} md={3}>
                        <FormControl fullWidth>
                          <InputLabel>Hair Color</InputLabel>
                          <MUISelect
                            multiple
                            name="hairColor"
                            value={roleForm.hairColor}
                            onChange={handleChange}
                            input={<OutlinedInput label="Hair Color" />}
                            renderValue={(selected) =>
                              (selected || []).join(", ")
                            }
                          >
                            {hairColorOptions
                              .filter((color) => color.activeFlag)
                              .map((color) => (
                                <MenuItem
                                  key={color.hairColorId}
                                  value={color.hairColorName}
                                >
                                  <Checkbox
                                    checked={roleForm.hairColor.includes(
                                      color.hairColorName,
                                    )}
                                  />
                                  <ListItemText primary={color.hairColorName} />
                                </MenuItem>
                              ))}
                          </MUISelect>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              </Box>

              <MeasurementsSection
                measurementFields={measurementFields}
                roleForm={roleForm}
                handleChange={handleChange}
                setRoleForm={setRoleForm}
                errors={errors}
              />
              {/* Vocal Characteristics */}
              <Accordion sx={{ mt: 3 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h6">Vocal Characteristics</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <FormControl component="fieldset" fullWidth sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Vocal Range
                    </Typography>
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={roleForm.vocalRange.includes("Any")}
                            onChange={() =>
                              handleVocalChange("vocalRange", "Any")
                            }
                          />
                        }
                        label="Any"
                      />
                      {vocalRangeOptions
                        .filter((v) => v.activeFlag)
                        .map((v) => (
                          <FormControlLabel
                            key={v.vocalRangeId}
                            control={
                              <Checkbox
                                checked={roleForm.vocalRange.includes(
                                  v.vocalRangeName,
                                )}
                                onChange={() =>
                                  handleVocalChange(
                                    "vocalRange",
                                    v.vocalRangeName,
                                  )
                                }
                              />
                            }
                            label={v.vocalRangeName}
                          />
                        ))}
                    </FormGroup>
                  </FormControl>

                  <FormControl component="fieldset" fullWidth>
                    <Typography variant="subtitle1" gutterBottom>
                      Vocal Style
                    </Typography>
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={roleForm.vocalStyle.includes("Any")}
                            onChange={() =>
                              handleVocalChange("vocalStyle", "Any")
                            }
                          />
                        }
                        label="Any"
                      />
                      {vocalStyleOptions.map((v) => (
                        <FormControlLabel
                          key={v.vocalTypeId}
                          control={
                            <Checkbox
                              checked={roleForm.vocalStyle.includes(
                                v.vocalTypeName,
                              )}
                              onChange={() =>
                                handleVocalChange("vocalStyle", v.vocalTypeName)
                              }
                            />
                          }
                          label={v.vocalTypeName}
                        />
                      ))}
                    </FormGroup>
                  </FormControl>
                </AccordionDetails>
              </Accordion>

              <Box mt={4} mb={2} display="flex" justifyContent="space-between">
                <Button
                  variant="outlined"
                  onClick={() => {
                    navigate(`/post-casting-call/${noticeId}`, {
                      state: { casting: casting, noticeId: noticeId },
                    });
                  }}
                >
                  Back
                </Button>

                <Button
                  variant="contained"
                  onClick={submitRoleToServer}
                  disabled={isLoading}
                >
                  {roleId ? "Update Role" : "Save this Role"}
                </Button>
                <button
                  onClick={handleSaveAndContinue}
                  style={{
                    backgroundColor: roles.length === 0 ? "#d3d3d3" : "#90b5fe",
                    color: roles.length === 0 ? "#a9a9a9" : "#fff",
                    cursor: roles.length === 0 ? "not-allowed" : "pointer",
                    border: "none",
                  }}
                  disabled={isLoading || roles.length === 0}
                >
                  Preview Notice
                </button>
              </Box>
            </Box>
            <Box
              sx={{
                width: { xs: "100%", md: "25%" },
                p: 1,
                backgroundColor: "#202020",
                borderRadius: "3px",
                color: "#eee",
              }}
            >
              <Typography
                variant="h5"
                sx={{ textAlign: "center", paddingTop: "20px" }}
              >
                <strong>Added Roles</strong>
              </Typography>
              {roles.length === 0 ? (
                <Typography>No roles added yet.</Typography>
              ) : (
                <Grid container spacing={2} mt={2}>
                  {roles.map((role) => (
                    <Grid item xs={12} md={12} key={role.id}>
                      <Card variant="outlined">
                        <CardContent style={{ paddingBottom: 0 }}>
                          <Typography variant="h6">
                            <strong>{role.roleName}</strong>
                          </Typography>
                          <Typography variant="body2">
                            Age: {role.ageStart}-{role.ageEnd}, Gender:{" "}
                            {Array.isArray(role.sex)
                              ? role.sex.join(", ")
                              : role.sex}
                            , Type: {role.roleType}
                          </Typography>
                        </CardContent>
                        <CardActions>
                          <IconButton
                            onClick={() => handleEdit(role.roleId, role)}
                            sx={{ color: "rgb(144, 181, 254)" }}
                          >
                            <EditIcon />
                          </IconButton>

                          <IconButton
                            onClick={() =>
                              deleteRole(role.roleId, role.roleName)
                            }
                            sx={{ color: "error.main" }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
      <Footer />
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={() => setToast({ ...toast, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setToast({ ...toast, open: false })}
          severity={toast.severity}
          sx={{ width: "100%" }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default RoleCreator;